function PlanAccordion() {
  const accordions = document.querySelectorAll('[data-accordion="true"]');

  if (!accordions.length) {
    return;
  }

  accordions.forEach((accordion) => {
    let blockClass = 'plan-accordion';

    if (accordion.closest('.levels-of-support')) {
      blockClass = 'levels-of-support';
    }

    if (accordion.closest('.content-image-list')) {
      blockClass = 'content-image-list';
    }

    const items = accordion.querySelectorAll(`.${blockClass}__item`);

    items.forEach((item) => {
      const trigger = item.querySelector(`.${blockClass}__trigger`);
      const panel = item.querySelector(`.${blockClass}__panel`);

      if (!trigger || !panel) {
        return;
      }

      // Важно: убираем hidden, если он остался в HTML
      panel.removeAttribute('hidden');

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((otherItem) => {
          const otherTrigger = otherItem.querySelector(`.${blockClass}__trigger`);

          otherItem.classList.remove('is-open');

          if (otherTrigger) {
            otherTrigger.setAttribute('aria-expanded', 'false');
          }
        });

        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });
}

export default PlanAccordion;
